<template>
  <v-snackbar v-model="show" :timeout="-1" color="primary" bottom right>
    <v-icon left dark>mdi-update</v-icon>
    A new version is available.
    <template #action="{ attrs }">
      <v-btn text v-bind="attrs" @click="reload"> Refresh </v-btn>
      <v-btn icon v-bind="attrs" @click="show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
// Polls version.json (written at build time, see vue.config.js) and compares
// its buildId to the one baked into this bundle. When they differ, a newer
// build has been deployed, so we surface a refresh prompt.
const POLL_INTERVAL_MS = 5 * 60 * 1000; // every 5 minutes
const INITIAL_DELAY_MS = 15 * 1000; // first check shortly after load

export default {
  name: "UpdateNotification",
  data: () => ({
    show: false,
    currentBuildId: process.env.VUE_APP_BUILD_ID,
    initialTimer: null,
    pollTimer: null,
  }),
  mounted() {
    // An initial check catches the case where this tab was served a stale
    // (cached) bundle while a newer build is already live. Then poll on an
    // interval, and whenever the tab regains focus.
    this.initialTimer = setTimeout(this.check, INITIAL_DELAY_MS);
    this.pollTimer = setInterval(this.check, POLL_INTERVAL_MS);
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    window.addEventListener("focus", this.check);
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    onVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.check();
      }
    },
    async check() {
      // Already prompting, or we don't know our own build id — nothing to do.
      if (this.show || !this.currentBuildId) {
        return;
      }

      try {
        const base = process.env.BASE_URL || "/";
        const response = await fetch(`${base}version.json?_=${Date.now()}`, {
          cache: "no-store",
        });
        if (!response.ok) {
          return;
        }

        const data = await response.json();
        if (data && data.buildId && data.buildId !== this.currentBuildId) {
          this.show = true;
          // No need to keep polling once we've told the user.
          this.stopPolling();
        }
      } catch (e) {
        // Network hiccup, or a non-JSON response (e.g. an SPA fallback
        // serving index.html) — ignore and try again next time.
      }
    },
    stopPolling() {
      clearTimeout(this.initialTimer);
      clearInterval(this.pollTimer);
      document.removeEventListener("visibilitychange", this.onVisibilityChange);
      window.removeEventListener("focus", this.check);
    },
    reload() {
      window.location.reload();
    },
  },
};
</script>
